<template>
    <div>
        <StepHeader
            :subtitle="subtitle"
            :description="description"
        />
        <StepBtnGroup
            class="mt-6 step-group media"
            :fields="fields"
            :selectedValue="selectedMedia"
            :orientation="'column'"
            layout="'full-width'"
            @select-value="selectMedia"
        />
    </div>
</template>

<script>
    import StepHeader from '@/components/myHabiteoStudio/steps/components/StepHeader';
    import StepBtnGroup from '@/components/myHabiteoStudio/steps/components/StepBtnGroup';

    export default {
        name: 'StepMedia',
        components: {
            StepHeader,
            StepBtnGroup
        },
        props: {
            subtitle: {
                type: String,
                required: true
            },
            description: {
                type: String,
                required: true
            },
            forms: {
                type: Array,
                required: true
            },
            selectedMedia: {
                type: Number,
                required: false
            }
        },
        computed: {
            fields() {
                return this.$props.forms[0].inputs[0].fields;
            }
        },
        methods: {
            selectMedia(media) {
                this.$props.forms[0].inputs[0].value = media;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/StepMedia.vue